import { showFromFade } from "../../js/Util";

let $btnMoreNews = $(".js-btn-more-news");
let $target = $(".js-news-list");
let url = $target.attr("data-url");
let page = Number($target.attr("data-page"));

App.W.width() < 768
    ? $target.attr("data-mobile", "on")
    : $target.attr("data-mobile", "off");
let statusMobile = $target.attr("data-mobile");

// флаг по которому отправляем повторно запрос только если в ответе не пусто
let switchRequest = true;

App.D.on("click", ".js-btn-more-news", function (e) {
    e.preventDefault();
    $(this).addClass("_loading");

    let tag = $(".js-news-tags").find("._active").attr("data-tag");
    let $target = $(".js-news-list");
    let currentPage = parseInt($target.attr("data-page"));
    $target.attr("data-page", currentPage + 1);

    setTimeout(() => {
        getNewsByParams(tag, currentPage);
    }, 200);
});

$(".js-news-tags div").click(function (e) {
    e.preventDefault();
    let $el = $(this);
    $target.empty();
    $target.attr("data-page", 2);
    $el.siblings("div").removeClass("_active");
    $el.addClass("_active");
    let currentTag = $el.attr("data-tag");
    getNewsByParams(currentTag, 1);

    if (App.W.width() < 768) {
        let totalWidth = 0;
        $el.closest(".js-news-tags")
            .find("div")
            .each(function () {
                totalWidth += $(this).outerWidth();
            });

        if ($el.index() === 0 || $el.index() === 1 || $el.index() === 2) {
            $el.closest(".js-news-tags").animate({
                scrollLeft: 0,
            });
        } else {
            $el.closest(".js-news-tags").animate({
                scrollLeft: totalWidth,
            });
        }
    }
});

function getNewsByParams(tag, page) {
    let $target = $(".js-news-list");
    let url = $target.attr("data-url");
    let $btnMoreNews = $(".js-btn-more-news");
    $.ajax({
        url: url,
        method: "get",
        dataType: "html",
        data: {
            tag: tag,
            page: page,
            mobile: statusMobile,
        },
        success: function (data) {
            let dataObj = JSON.parse(data);
            if (dataObj.content) {
                $target.append(dataObj.content);

                // Параметры фильтров в урл
                const baseUrl =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname;
                let newUrl = baseUrl + `?page=${page}&tag=${tag}`;

                if (!$(".js-news-tags").length) {
                    newUrl = baseUrl + `?page=${page}`;
                }

                $btnMoreNews.removeClass("_loading");

                history.pushState(null, null, newUrl);
            } else {
                $btnMoreNews.removeClass("_loading");
                switchRequest = false;
            }

            if (dataObj.last || !dataObj.content) {
                $btnMoreNews.addClass("_hidden");
            } else {
                $btnMoreNews.removeClass("_hidden");
            }
        },
    });
}

if (App.W.width() < 768 && page === 2) {
    hideCadrsMobile();
}

App.W.on("resize", function () {
    if (App.W.width() < 768 && page === 2) {
        hideCadrsMobile();
    } else {
        return false;
    }
});

function hideCadrsMobile() {
    let $card = $target.find("a");

    $card.each(function (idx, itm) {
        if (idx > 2) {
            $(itm).remove();
        }
    });
}

if ($(".news").length) {
    $(".news").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
